import { connect } from 'react-redux';
import DeclarationPage from './DeclarationPage';
import { getData } from '../../../state/reducers/ApplicationReducer';
import {
  hasDeclared,
  hasReadTerms,
} from '../../../state/reducers/DeclarationReducer';
import {
  isFetching,
  getError,
  getMappedFees, getPaymentRecord,
} from '../../../state/reducers/PaymentReducer';
import { isLoaded } from '../../../state/reducers/ConfigReducer';
import DeclarationOfApplicantActions from '../../../state/actions/DeclarationActions';
import PaymentActions from '../../../state/actions/PaymentActions';
import { isLAO } from '../../../state/reducers/LoginReducer';
import ApplicationActions from '../../../state/actions/ApplicationActions';

const mapStateToProps = (state) => {
  const didDeclare = hasDeclared(state);
  const didReadTerms = hasReadTerms(state);
  const fees = getMappedFees(state) || {};
  const { visatypeId, countryId, uuid } = getData(state);
  const zeroPayment = state.application.zeroPayment || null;
  const fee = fees[countryId] || fees['1'] || {};

  return {
    uuid,
    zeroPayment,
    isLAO: isLAO(state),
    visatypeId,
    application: getData(state),
    isFetching: isFetching(state) || state.application.fetching,
    isLoaded: isLoaded(state),
    error: getError(state),
    hasDeclared: didDeclare,
    hasReadTerms: didReadTerms,
    canPay: didDeclare && didReadTerms,
    amount: fee.amount || '',
    currency: fee.currency || '',
    canProceed: didDeclare && didReadTerms && (fee.amount || 0) >= 0,
    paymentRecord: getPaymentRecord(state),
    fee,
  };
};

const {declared, readTerms} = DeclarationOfApplicantActions;
const {getFeesRequest, getQuoteRequest, submitPaymentRequest, submitZeroPayment} = PaymentActions;
const {saveRequest, submitRequest, checkZeroPayment} = ApplicationActions;

export default connect(mapStateToProps, {
  declarationChanged: declared,
  readTermsChanged: readTerms,
  save: saveRequest,
  submit: submitRequest,
  loadFees: getFeesRequest,
  getQuote: getQuoteRequest,
  checkZeroPayment: checkZeroPayment,
  submitZeroPayment: submitZeroPayment,
  submitPaymentRequest,

})(DeclarationPage);



// WEBPACK FOOTER //
// ./src/view/scenes/Declaration/index.js